import { createApp, h } from "vue";
import router from "./Router";
import App from './App.vue'
import pinia from "./Plugins/pinia";

import bootstrap from "bootstrap";

createApp(App)
    .use(router)
    .use(pinia)
    .mount('#app')
